export default {
  // Search and filter
  modelNamePlaceholder: 'Model Name',
  refreshImages: 'Refresh Images',
  selectAll: 'Select All',
  deselectAll: 'Deselect All',
  reasoning: 'Reasoning',

  // Hints and tips
  selectionHint: '{count} images total, check and click reasoning',
  reasoningWithCount: 'Reasoning ({count} selected)',
  emptyDescription: 'No images, please click refresh',

  // Messages
  noImagesFound: 'No images found',
  queryImagesFailed: 'Failed to query images',
  pleaseSelectImages: 'Please select images first',
  reasoningCompleted: 'Reasoning completed',
}
